import { render, staticRenderFns } from "./changepasd.vue?vue&type=template&id=2c49546c"
import script from "./changepasd.vue?vue&type=script&lang=js"
export * from "./changepasd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports